export default __webpack_public_path__ + "static/media/lacteos.e8300e83.svg";